import React, { useState, useEffect } from "react";
// import { withSnackbarConsumer, Color } from "../../../contexts/SnackbarContext/SnackbarContext.jsx";
import { withSnackbarConsumer, Color } from "contexts/SnackbarContext/SnackbarContext.jsx";
import { useZoomShortcut } from "utils/zoom";

const Notifications = ({
  snackbarContext,
}) => {
  useZoomShortcut(snackbarContext);
  return <React.Fragment />;
};

export default withSnackbarConsumer(Notifications);
